var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Kategorie bearbeiten"}},[_c('event-category-form',{attrs:{"loading":_vm.loading,"category":_vm.category,"form-submitted":_vm.saveCategory,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }